import React, { Component } from 'react';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import { Timeline } from '@components/common';

class ScheduledClockedTime extends Component {
	shouldComponentUpdate = ({ data : nextData }) => {
		const { data } = this.props;
		return (
			!isEqual(data, nextData)
		);
	}

	render() {
		const { data } = this.props;
		return (
			<div className="flex margin-top-40">
				<For
					each="item"
					of={data}
				>
					<Timeline
						key={item.header}
						header={item.header}
						outerClassName={item.outerClassName}
						data={item.data}
					/>
				</For>
			</div>
		);
	}
}

ScheduledClockedTime.propTypes = {
	data : PropTypes.array,
};

ScheduledClockedTime.defaultProps = {
	data : [],
};

export default ScheduledClockedTime;
